export const paginationLocale = {
    ellipsis: '…',
    previous: 'Previous',
    next: 'Next',
    ariaLabel: 'Pagination',
    ariaGoToPrevious: 'Go to previous page',
    ariaGoToNext: 'Go to previous page',
    ariaCurrentPage: (page) => `Page ${page}, current page`,
    ariaGoToPage: (page) => `Go to page ${page}`,
};
//# sourceMappingURL=Pagination.locale.js.map